import { useEffect, useMemo, useState } from "react";
import { base58, keccak256 } from "ethers/lib/utils.js";
import EllipticCurve from "elliptic";
import { ec as EC } from "elliptic";
import { useContext } from "react";
import { AppContext } from "./Container";
import Abi from "../artifacts/contracts/wRats.sol/wRats.json";
import { BsChevronDown } from "react-icons/bs";
import { ethers } from "ethers";
import { Notyf } from "notyf";
import BigNumber from "bignumber.js";
import { AvaxMetaData } from "../Helpers/AvaxMetaData"
import "notyf/notyf.min.css";
import { BiTransfer } from "react-icons/bi";
import { TokenABI } from "../Helpers/TokenABI";
import { IsConnected } from "../Helpers/IsConnected";
import { useLocation } from 'react-router-dom';


const ec = new EllipticCurve.ec("secp256k1");

const Transfer = () => {

  const notyf = new Notyf();


  const location = useLocation();


  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const key = searchParams.get('key');

    if (key) {
      setwratsKey(key);
      
    }
  }, [location.search ,]);



  let network: string | any = sessionStorage.getItem("chain");



  const { accountChecker } = useContext(AppContext);
  const [ContractAddress, setContractAddress] = useState<string | any>("");




  const { ethereum }: any = window;


  let x_cor: string | '';
  let y_cor: string | '';
  let sharedSecret: string | '';

  const [token, settoken] = useState<string | "">("");
  const [wratsKey, setwratsKey] = useState<string | "">("");
  const [error, seterror] = useState<string | "">("");
  const [amount, setamount] = useState<string | "">("");
  const [show, setshow] = useState<boolean>(false);
  const [byDefault, setbyDefault] = useState<string>("ETH");
  const [chainList, setchainList] = useState<any>([])
  const [txId, settxID] = useState<string | "">("");


  const sender = useMemo(() => {

    return sessionStorage.getItem("address");

  }, [])


  const provider = useMemo(() => {

    return new ethers.providers.Web3Provider(ethereum);

  }, [ethereum])


  var receipentAddress: string;


  useMemo(() => {

    AvaxMetaData.map((chain: any) => {

      if (network === chain.name) {
        setbyDefault(chain.currency.symbol);
        settxID(chain.url)
        setContractAddress(chain.contract)
        setchainList(chain.tokens)
      }

      return false

    });
   

  }, [network]);



  console.log(chainList, network, ContractAddress, txId);

  const [trxid, settrxid] = useState<string>("");
  const [waiting, setwaiting] = useState<boolean>(false);
  const [buttonState, setButtonState] = useState<string>(
    !sessionStorage.getItem("address") ? "Connect Wallet" : "Transfer"
  );




  //helpers functuion to validate wRats  keys


  const validatingWratsKey = (event: any) => {


      const key = event.target.value;

      if (key !== '') {
        if (
          (key.slice(0, 6).toLowerCase() !== "wrats-" && (key.length > 53 || key.length < 53))) {
          seterror("Invalid address");
          setTimeout(() => {
            seterror("");
          }, 600);
        }
      }
  
  
      setwratsKey(key);
  
    

   
  };

  const validateInputs = () => {


    if (wratsKey === "" || amount === "") {
      seterror("Please fill the inputs");
      setTimeout(() => {
        seterror("");
      }, 3000);
      return;
    }
  }





  //receipent public key or Link
  let shared_wratsKey: EC.KeyPair ;



  //ec keypair use to generate private numbers and public stealth address
  let keypair: EC.KeyPair = ec.genKeyPair();

  //one time ephemeral public key to be published in wRats directory contract
  let ephPublicKey: any = keypair.getPublic();





  const validatewratsKey = async () => {

    /*
       removing the prefix "wrats-" 
  */


    try {

      if (wratsKey.slice(0, 6).toLowerCase() === "wrats-") {
        const _wratsKey = wratsKey.slice(6);

        /*
         removing the one bytes suffix from the  key then decoding it to generate an stealth address
    */
        let decode_wratsKey = base58.decode(_wratsKey);

        const decodedkey = decode_wratsKey.subarray(0, 33);
        shared_wratsKey = ec.keyFromPublic(decodedkey, "hex");

      } else {
        seterror("Invalid key");
      }

    
    } catch (e: any) {
      seterror(e.message);
    }
  }





  const setUpStealthAddress = async () => {


    validatewratsKey()
    /*
         Generating the stealth address by doing some elliptic curve calculation here
      */

    try {
      const calculateSecret = keypair.derive(shared_wratsKey.getPublic());
      const hashedSecret = ec.keyFromPrivate(keccak256(calculateSecret.toArray()));
      const publicKey = shared_wratsKey?.getPublic()?.add(hashedSecret.getPublic())?.encode("array", false);

      //P = H(r*A) * G + B

      //generating wallet address from public key

      const _publicKey = publicKey?.splice(1) || []

      const address = keccak256(_publicKey);

      const _HexAddress = address.slice(-40);

      receipentAddress = "0x" + _HexAddress;


      //x and y co-ordinate of ephemeral public key
      x_cor = "0x" + ephPublicKey?.getX().toString(16, 64) || "";
      y_cor = "0x" + ephPublicKey?.getY().toString(16, 64) || "";

      // 1byte shared secret prefixed with ephemeral public key

      sharedSecret = "0x" + calculateSecret.toArray()[0].toString(16) ;

    } catch (e) {
      console.log("error", e);
    }

    return true;
  };







  const Transfer = async () => {

    if (sessionStorage.getItem("address") === null) accountChecker()

    //

    setUpStealthAddress();

    //

    validateInputs();

    setwaiting(true);

    //

    const signer = provider.getSigner();
    const contract = new ethers.Contract(ContractAddress, Abi.abi, signer);



    try {
    
      const transferFundsToStealthAddress = await contract.TransferAvax(
        x_cor,
        y_cor,
        sharedSecret,
        receipentAddress,
        {value : ethers.utils.parseEther(amount)}
      );
 

      const trx = await transferFundsToStealthAddress;

      await trx.wait

      settrxid(txId + trx.hash);


      setamount("");
      setwratsKey("");




    } catch (e: any) {
      console.log(e);
      seterror(e.message);
    }
    setwaiting(false);
  };







  const TransferToken = async () => {

    //

    setUpStealthAddress();

    //

    validateInputs()

    setwaiting(true);



    const signer = provider.getSigner();
    const contract = new ethers.Contract(ContractAddress, Abi.abi, signer);


    try {

      //to send exact amount of tokens are always counted as  amount**18
      const amountParams: any = ethers.utils.parseUnits(amount, 18);


      try {
        const transferERC20ToStealthAddress = await contract.TransferERC20(
          x_cor,
          y_cor,
          sharedSecret,
          token,
          receipentAddress,
          amountParams
        );

        const trx = await transferERC20ToStealthAddress;
        await trx.wait

        settrxid(txId + trx.hash);


      } catch (err: any) {
        console.log(err.message);
        seterror(err.message);
      }



    } catch (e: any) {
      console.log(e);
      seterror(e.message);
    }
    setwaiting(false);
  };

  async function approve() {

    const signer = provider.getSigner();
    const contract = new ethers.Contract(token, TokenABI, signer);


    try {
      const allowance = await contract.allowance(
        sender, ContractAddress

      );

      const bigNumber = new BigNumber(allowance._hex);
      const _allowance: number = bigNumber.toNumber() / 10 ** 18;


      if (_allowance < Number(amount)) {

        const approvedAmount: any = ethers.utils.parseUnits(amount, 18);
        const approve = await contract.approve(
          ContractAddress,
          approvedAmount

        );
        setButtonState("Approving..");

        const txResponse = await approve;
        await txResponse.wait
        console.log(txResponse)


        setButtonState("Transfer");

        notyf.success("Approved");

        setTimeout(() => {

          TransferToken();

        }, 2000);

      } else {
        TransferToken();
      }

    } catch (e: any) {
      console.log(e.message);
      seterror(e.message);
    }
  }

  async function proceed() {


    //checking is ethereum connected

    IsConnected()

    // validateChain();

    const contract = new ethers.Contract(token, TokenABI, provider);

    try {
      const balance = await contract.balanceOf(sender);
      const bigNumber = new BigNumber(balance._hex);

      const erc20Balance: any = bigNumber.toNumber() / 10 ** 18;

      if (erc20Balance >= amount) {
        approve();

      } else {
        notyf.error("insufficient token balance");
      }
    } catch (err: any) {

      console.log(err.message);
      seterror(err.message);
    }
  }

  const changedefaultval = (c: any) => {
    setshow(!show);
    setbyDefault(c.name);
    settoken(c.address);
  };

  const viewtrx = () => {
    if (trxid !== "") {
      window.open(trxid, "_blank");
    }
  };

  return (
    <div className="flex flex-col justify-center items-start space-y-2">
      <div
        className="text-bgGray w-[100%] rounded-md 
       "
      >

        <input
          className="my-4 text-[0.9rem] font-semibold text-gray-300  placeholder:text-gray-500
          montserrat-subtitle outline-none px-3 py-3 h-[100%] rounded-md
           hover:border-cyan-900 w-[100%] bg-black/10 border-2 border-gray-600"
          type="text"
          onChange={validatingWratsKey}
          placeholder="Paste Receipents key"
          value={wratsKey}
        />
      </div>
      {/* Amount */}
      <div className="text-bgGray w-[100%] pb-4 rounded-md">

        <div
          className="relative flex items-center  py-1 w-[100%] hover:shadow-sm rounded-md         
       "
        >
          <input
            className="text-[0.9rem] font-semibold text-gray-300  placeholder:text-gray-500
          montserrat-subtitle outline-none py-3 px-3 h-[100%] rounded-md
          hover:border-cyan-900 w-[100%] bg-black/10 border-2 border-gray-600"
            value={amount}
            type="text"
            placeholder={`0.1  ${byDefault}`}
            onChange={(e) => setamount(e.target.value)}
          />
          {/* Tokens Dropdown Menu */}
          <div className="min-w-[95px] absolute right-1 ">
            <ul className="" onClick={() => setshow(!show)}>
              <li
                className="flex p-2 px-3 cursor-pointer rounded-md  font-semibold border-l border-gray-700
            items-center gap-2 text-[#ee6f08]"
              >
                <p>{byDefault}</p>
                <BsChevronDown size={18} />
              </li>
              <div
                className={`
              ${show &&
                  `transition-all ease-in bg-bgGray py-1 shadow-md flex flex-col w-[105%] max-h-28 rounded-b-md absolute mt-2
                scrollbar-thin scrollbar-thumb-bgGray scrollbar-track-[#dbe6eb] overflow-y-scroll 
               scrollbar-thumb-rounded scrollbar-rounded-full`
                  }
            `}
              >
                {show &&
                  chainList.map((c: any) => (
                    <div className="h-40 border-b border-gray-400 ">
                      <li
                        className="flex flex-row-reverse p-1 px-3 cursor-pointer
                    text-gray-900 font-semibold border-l border-gray-100 
                    items-center gap-2 hover:text-gray-900 hover:bg-[#dbe6eb] 
                    montserrat-small text-[0.8rem]
                    justify-between"
                        key={c.name}
                        onClick={() => changedefaultval(c)}
                      >
                        <img
                          className=" rounded-lg"
                          src={c.symbol}
                          alt=""
                          height={14}
                          width={18}
                        />
                        <p>{c.name}</p>
                      </li>
                    </div>
                  ))}
              </div>
            </ul>
          </div>
        </div>
      </div>
      <div className="w-full flex justify-center mr-4">
        <button
          onClick={() => {
            const selectedChain = AvaxMetaData.find((chain: any) => chain.currency.symbol === byDefault);
            if (selectedChain) {
              Transfer(); // Call Transfer function if the condition is met
            } else {
              proceed(); // Call proceed function otherwise
            }
          }}
          className="flex space-x-2 justify-center w-[100%] mx-auto mb-4 my-2 montserrat-subtitle  py-2 montserrat-subtitle  
          hover:shadow-xl px-6 text-center text-black highlight 
          rounded-md font-bold  transition-all ease-linear"
        >
          {waiting === false ? (
            <>
              <BiTransfer className="text-[1.3rem] text-inherit" />
              <span>{buttonState}</span>
            </>
          ) : (
            'transfering...'
          )}
        </button>
      </div>

      <p
        onClick={viewtrx}
        className="montserrat-subtitle flex mx-auto items-center animate-pulse-2s montserrat-small  text-[#ee6f08]  text-center font-semibold underline underline-offset-8 decoration-bgGray cursor-pointer"
      >
        {trxid ==='' ? '' : '   Successfully Sent ! Click to view'}
    
      </p>
      <p className="montserrat-subtitle text-gray-600 font-semibold flex mx-auto items-center">
        {error}
      </p>
    

    </div>
  )
};

export default Transfer;